module.exports = __webpack_public_path__ + "LatoLatin-HairlineItalic.cec442a2c87a7a1a7ae8.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-HairlineItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-HairlineItalic.eot
// module chunks = styles